// Browser timezone, read live at request time and sent with /api/chat.
//
// Only the IANA timezone is browser-sourced — it can't be inferred from the
// chat text, and we need it to know what time it is for the user (the SMS coach
// uses local time for message timing and the "late-night eating" pattern). The
// handoff's locale.language is NOT taken from the browser: navigator.language
// describes the device, not how the user chose to talk. Language is detected
// server-side from the conversation instead (see chat.ts detectConversationLanguage).
//
// Unlike attribution (which races the query string at bootstrap), timezone is
// available synchronously any time and is stable within a session, so there's
// nothing to capture-and-stash — we just read it per request.

export interface Locale {
  timezone?: string
}

export function readLocale(): Locale | null {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (tz) return { timezone: tz.slice(0, 64) }
  } catch {
    // Intl/timezone unavailable — best-effort
  }
  return null
}
